import React, { useEffect, useState } from 'react';
import {
  getNotifications,
  getJourney,
  getRejectNotifications,
  getRequests,
} from '../components/API';
import { useAuthContext } from '../contexts/Auth';
import { useCompanyContext } from '../contexts/Company';
import { getUserAttributes } from '../utils';
import LoadingBackdrop from '../components/LoadingBackdrop';
import mixpanel from '@8fig/mixpanel';
import Layout from '../components/Dashboard/Layout';

export default function Dashboard() {
  const { signedIn } = useAuthContext();
  const { business, getUserCompany } = useCompanyContext();
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState(null);
  const [rejectNotifications, setRejectNotifications] = useState(null);

  const [journey, setJourney] = useState(null);
  const [requests, setRequests] = useState(null);

  async function getJourneyInfo() {
    try {
      const journeyInfo = await getJourney();
      setJourney(journeyInfo);
    } catch (error) {
      setJourney({});
    }
  }

  async function getRequestsInfo() {
    try {
      const requestsInfo = await getRequests();
      setRequests(requestsInfo);
    } catch (error) {
      setRequests({});
    }
  }

  async function getNotificationsInfo() {
    try {
      const notificationsInfo = await getNotifications();
      const user = await getUserAttributes();
      if (
        !user.email_verified ||
        !user['custom:first_name'] ||
        !user['custom:last_name']
      ) {
        notificationsInfo.push({
          type: 'account',
          message: 'Your user account is incomplete',
        });
      }
      setNotifications(notificationsInfo);
    } catch (error) {
      setNotifications([]);
    }
  }

  async function getRejectNotificationsInfo() {
    try {
      const rejectNotifications = await getRejectNotifications();
      setRejectNotifications(rejectNotifications);
    } catch (error) {
      setRejectNotifications([]);
    }
  }

  async function getCompanyInfo() {
    if (!business) {
      await getUserCompany();
    }
  }

  async function getDashboardInfo() {
    setLoading(true);
    await Promise.all([
      getCompanyInfo(),
      getNotificationsInfo(),
      getJourneyInfo(),
      getRequestsInfo(),
      getRejectNotificationsInfo(),
    ]);
    setLoading(false);
  }

  useEffect(() => {
    getDashboardInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (journey) {
      mixpanel.people.set({
        'Number of products': journey.products,
      });
    }
  }, [journey]);

  return (
    <React.Fragment>
      <LoadingBackdrop open={loading || !signedIn} />
      {notifications && journey && business && requests && signedIn && (
        <Layout
          notifications={notifications}
          journey={journey}
          requests={requests}
          setRequests={setRequests}
          company={business}
          rejectNotifications={rejectNotifications}
          setRejectNotifications={setRejectNotifications}
        />
      )}
    </React.Fragment>
  );
}
